type ParamsProp = Record<string, string | number>;

export const injectEndpointUrlParams = (endpoint: string, params: ParamsProp = {}) => {
    let injectedEndpoint = endpoint;
    const paramsKeys = Object.keys(params);
    if (paramsKeys.length > 0) {
        paramsKeys.forEach((paramKey) => {
            if (params[paramKey] !== undefined && params[paramKey] !== null) {
                injectedEndpoint = injectedEndpoint.replace(
                    `%${paramKey}%`,
                    params[paramKey].toString()
                );
            }
        });
    }
    return injectedEndpoint;
};
